import { h, render } from 'vue';
import type { Component } from 'vue';

export function usePopup(className?: string, rootElement?: HTMLElement) {
  const root = rootElement || document.getElementById('app') as HTMLElement;
  let cacheClass = 'popup-container';
  if (className) {
    cacheClass = className;
  };
  function mount<U>(component: Component, options: U = {} as U) {
    const el = document.createElement('div');
    el.className = cacheClass;
    root.appendChild(el);
    const vnode = h(component, Object.assign({
      onClose: () => {
        unMount();
      }
    }, options));
    render(vnode, el);
  }
  function unMount() {
    let firstClassName = '';
    if (cacheClass.split(' ').length) {
      firstClassName = cacheClass.split(' ')[0];
    }
    const el = root.querySelector(`.${firstClassName}`);
    if (el) {
      // 卸载组件，触发 onUnmounted 钩子
      render(null, el);
      root.removeChild(el);
    };
  }
  function isMounted() {
    let firstClassName = '';
    if (cacheClass.split(' ').length) {
      firstClassName = cacheClass.split(' ')[0];
    }
    const el = root.querySelector(`.${firstClassName}`);
    return Boolean(el);
  }
  /** 关闭devui的modal弹窗  */
  function closeModal() {
    const el = document.body.querySelector('.devui-modal');
    const mask = document.body.querySelector('.devui-modal__overlay');
    if (el) { (el as HTMLElement).style.display = 'none'; }
    if (mask) { (mask as HTMLElement).style.display = 'none'; }
  }
  /** 恢复devui的modal弹窗 */
  function refreshModal() {
    const el = document.body.querySelector('.devui-modal');
    const mask = document.body.querySelector('.devui-modal__overlay');
    if (el) { (el as HTMLElement).style.display = 'block'; }
    if (mask) { (mask as HTMLElement).style.display = 'block'; }
  }
  return {
    mount,
    isMounted,
    unMount,
    closeModal,
    refreshModal
  };
}
